module.exports = __webpack_public_path__ + "img/activity_h5bg.22fa4456.png";